import { CartSummaryProps } from "@made-people/blueprint-cart-summary";
import { getSubtotal } from "../../../utils/format-like-price";

export const CartSummary: CartSummaryProps = {
  templateProps: {
    template: "birch",
    cartTotalsSettings: {
      fieldsEnabled: {
        subtotal: false,
        discount: false,
        tax: false,
        shipping: true,
        grandTotal: true,
      },
      customRows: [
        {
          label: "Checkout_CartTotals_Subtotal",
          value: getSubtotal,
        },
      ],
    },
  },
};
